<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
  >
    <g clip-path="url(#clip0_622_2448)">
      <path
        d="M23.9425 5.50148C23.9729 4.69337 23.7217 3.89998 23.2341 3.25639C22.654 2.53064 21.8519 2.03048 20.9224 1.9023L7.30095 0.706656C6.37705 0.625826 5.45616 0.91509 4.74444 1.5123C4.03209 2.1104 3.58991 2.96627 3.50922 3.88829L2.07115 20.3255C1.99047 21.2477 2.27842 22.1674 2.87599 22.88C3.4732 23.5917 4.32889 24.0364 5.25279 24.1172L18.7024 25.2939C19.6266 25.3744 20.5452 25.0844 21.256 24.488C21.9529 23.8743 22.4115 23.0459 22.4931 22.1122L23.9312 5.67499L23.9425 5.50148Z"
        fill="white"
      />
      <path
        d="M20.5751 3.87765C20.9713 3.91241 21.3377 4.10321 21.5933 4.40786C21.8489 4.71258 21.9733 5.10646 21.9387 5.50267L20.5006 21.9399C20.4659 22.3361 20.275 22.7024 19.9704 22.9581C19.6657 23.2137 19.2717 23.338 18.8756 23.3034L5.42693 22.1268C5.03062 22.0922 4.66346 21.9013 4.40775 21.5965C4.15222 21.2918 4.02871 20.898 4.06337 20.5018L5.50144 4.0646C5.53611 3.66844 5.72611 3.30201 6.03068 3.04631C6.33543 2.79059 6.73015 2.66637 7.12647 2.70105L20.5751 3.87765ZM12.7395 15.9908C12.4424 15.9648 12.1465 16.0577 11.918 16.2493C11.6894 16.4411 11.5468 16.7163 11.5208 17.0135C11.5014 17.2352 11.548 17.4576 11.655 17.6526C11.7621 17.8477 11.9246 18.0064 12.1219 18.1091C12.3191 18.2118 12.5422 18.2541 12.7632 18.2299C12.9843 18.2057 13.1936 18.1166 13.364 17.9737C13.5344 17.8307 13.6584 17.64 13.7207 17.4265C13.783 17.2129 13.781 16.9853 13.7141 16.7731C13.6472 16.561 13.5191 16.3733 13.3457 16.234C13.1722 16.0948 12.9611 16.0103 12.7395 15.9908ZM13.5229 7.02597C12.4875 6.93538 11.6242 7.80778 11.7259 8.84208L12.195 13.6101L12.1885 13.684C12.1788 13.7951 12.1959 13.9049 12.2337 14.0076L12.2779 14.4545C12.3064 14.7429 12.5369 14.9703 12.8256 14.9955C13.1142 15.0206 13.3799 14.8367 13.458 14.5578L13.5767 14.1309C13.6338 14.0349 13.6729 13.9282 13.6828 13.8148L13.6906 13.7253L14.9762 9.12644C15.256 8.12562 14.5581 7.11671 13.5229 7.02597Z"
        fill="#FF6130"
      />
    </g>
    <defs>
      <clipPath id="clip0_622_2448">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(2.09174) rotate(5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {};
</script>
